import ApiCall from '../helpers/ApiCall';

// Endpoints of the Search page. `signal` (from an AbortController) cancels the request, e.g. when the page is left.
// Polled endpoints skip the request loader; the caller keeps the loader visible for the whole polling (trackLoading).

export const getLineCodes = ({ signal } = {}) => ApiCall('GetLineCode', 'GET', null, { signal });

export const getCountries = ({ signal } = {}) => ApiCall('GetCountry', 'GET', null, { signal });

export const getCities = (country, { signal } = {}) => ApiCall('GetCity', 'GET', null, { params: { country }, signal });

export const getLineCodesByCountries = (selection) => ApiCall('LineCodeByCountries', 'POST', selection);

export const createSearch = (search) => ApiCall('GetSearchId', 'POST', search);

export const getSearchResult = (id, { signal } = {}) =>
    ApiCall('GetSearchResult', 'GET', null, { params: { id }, signal, skipLoader: true });

export const getExcelResult = (id, { signal } = {}) =>
    ApiCall('GetExcelResult', 'GET', null, { params: { id }, signal, skipLoader: true });

export const confirmPiiWarning = () => ApiCall('WarningConfirmLog', 'POST', null);
